import ActionTypes from './ActionTypes';

const getAllPhotos = payload => {
    return{
        type: ActionTypes.GET_ALL_PHOTOS,
        payload,
    }
}
const getEventGalleryCategories = payload =>{
    return{
        type: ActionTypes.GET_EVENT_GALLERY_CATEGORIES,
        payload,
    }
}

const clearAllPhotos = () => {
    return{
        type: ActionTypes.CLEAR_ALL_PHOTOS,
    }
}

const getAlbum = payload => {
    return{
        type: ActionTypes.GET_ALBUM,
        payload,
    }
}
const clearAlbum = () => {
    return{
        type: ActionTypes.CLEAR_ALBUM,
    }
}



const getMyPhotos = payload => {
    return{
        type: ActionTypes.GET_MY_PHOTOS,
        payload,
    }
}

const clearMyPhotos = () => {
    return{
        type: ActionTypes.CLEAR_MY_PHOTOS,
    }
}

const updateMyPhotos = payload => {
    return{
        type: ActionTypes.UPDATE_MY_PHOTOS,
        payload,
    }
}


export { getAllPhotos, clearAlbum , getMyPhotos , updateMyPhotos , clearMyPhotos , clearAllPhotos , getAlbum , getEventGalleryCategories};